<template>
  <input ref="file" type="file" @change="s3upload()">
</template>

<script>
// usage:
// https://medium.com/@shresthshruti09/uploading-files-in-aws-s3-bucket-through-javascript-sdk-with-progress-bar-d2a4b3ee77b5

// cfg: {'target_folder_name': 'avatar/', 'compress_cfg': {maxWidth: 100, maxHeight: 100,}, filetype_allowed: ['png','jpg'], max_size: 3 }
// sync_obj: {'img_url': '','status_uploading': false,'status_upload_percent: ''}
export default {
  name: 'uniUpload',
  components: {},
  props: [
    'conf',
    'sync_obj',
  ],
  data() {
    return {
      max_size: 3,
    }
  },
  computed: {
    cfg(){
      if(this.conf){
        return this.conf
      }else{
        return {}
      }
    },
  },
  watch: {},
  methods: {

    async s3upload(){
      let v = this
      let files = v.$refs['file'].files;
      if (files && files[0]) {
        
        let file = files[0];

        // let file_type = file.type.split('/')[1]
        let file_type = file.name.substr( file.name.lastIndexOf('.') + 1 )
        console.log(file)
        console.log(file_type)
        if (!file_type) {
          alert('The file type is not supported')
          return
        }

        if(v.cfg.filetype_allowed && v.cfg.filetype_allowed.indexOf(file_type) === -1){
          alert('File types only supported: '+ v.cfg.filetype_allowed.join(',')+'.')
          return
        }

        let fileSize = file.size;
        let size = fileSize / 1024 / 1024;
        if (size > v.max_size) {
          alert('Max file size: '+v.max_size+'MB (now '+parseFloat(size.toFixed(1))+'MB).')
          return;
        }
        
        let fileName =  new Date().valueOf() + "" + Math.random().toString(36).substr(2).toUpperCase() + '.' + file_type;

        let filePath = (v.cfg.target_folder_name ? v.cfg.target_folder_name :'default_folder/') + fileName;


        // let fileUrl = `https://${'gonft'}.s3.${window.AWS.config.region}.amazonaws.com/${filePath}`
        let fileUrl = `https://${'jgnnft'}.s3.${window.AWS.config.region}.amazonaws.com/${filePath}`
        // let fileUrl = 'https://' + window.AWS.config.region + '.amazonaws.com/' +  filePath;

        // compressImg(gif暂不加入压缩，会丢失动画)
        if('jpg|jpeg|png'.indexOf(file_type) >= 0){
          file = await v.compressImg(file)
        }

        v.sync_obj.status_uploading = true
        window.aws_s3.upload(
          {
            Key: filePath,
            Body: file,
            ACL: 'public-read'
          }, 
          function(err, data) {
            if(err) {
              // reject('error');
              console.log('---------------')
              console.log(err);
            }
            // alert('Successfully Uploaded!');
            v.sync_obj.img_url = fileUrl
            v.sync_obj.status_uploading = false
          }
        ).on('httpUploadProgress', function (progress) {
          console.log('httpUploadProgress,',progress)
          v.sync_obj.status_upload_percent = parseInt((progress.loaded * 100) / progress.total)
        });
      }
    },

    async compressImg(file){
      let v = this
      let Compressor = window.Compressor || null
      if(!Compressor){
        console.log('Warn: no compressor.')
        return file
      }
      return new Promise(function(resolve,reject){

        let option = {
          checkOrientation: true,
          maxWidth: 1500,
          maxHeight: 1500,
          quality: 0.7,
          convertSize: 5000000,
          success: function(compressed_img) {
            console.log('image compressed.')
            resolve(compressed_img)
          },
          error: function(){
            reject(file)
          }
        }

        if(v.cfg.compress_cfg){
          option = Object.assign({},option,v.cfg.compress_cfg)
        }

        new Compressor(file,option)

      })
    },

    run(){
      let v = this

      if(v.cfg.max_size){
        v.max_size = v.cfg.max_size
      }

      if(!v.cfg.target_folder_name){
        console.log('WARN no .target_folder_name')
      }
    },

  },
  created() {
    
  },
  mounted() {
    if(!this.sync_obj){
      console.log("ERR.sync_obj")
      return
    }
    this.run()
  },
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  
</style>